import React from 'react';
import { InfoSection } from '../../components';
import {  homeObjThree } from './Data';

function Services() {
  return (
    <>
       <InfoSection {...homeObjThree} />
    </>
  );
}

export default Services;
